module.exports = __webpack_public_path__ + "img/20_100.d6f27fa0.png";